module.exports = __webpack_public_path__ + "img/43.4.NH3-N.e59e87ce.png";